import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function useTimeOfDayBreakdown(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ANALYTICS_QUERY_KEY, "time-of-day-breakdown", filters],
    queryFn: async () => {
      const { data, error } = await client.GET(
        "/api/analytics/time-of-day-breakdown",
        { params: { query: toAnalyticsQuery(filters) } },
      );
      if (error !== undefined) {
        throw new Error("Failed to load time-of-day breakdown");
      }
      return data;
    },
  });
}
